import { View } from 'react-native'
import Animated from 'react-native-reanimated'
import Typography from '@ui/typography'
import { leadingNone } from '@ui/typography/styles'
import cn from '@ui/utils/cn'
import { colors } from '@ui/colors'
import { ChipProps as Props } from './types'

export default function Chip({
  label,
  value,
  styleContainer,
  styleText,
}: Props) {
  const both = label && value

  return (
    <Animated.View
      style={[{ borderColor: colors.black10 }, styleContainer]}
      className="flex h-6 flex-row items-center justify-center gap-2 rounded-sm border px-2"
    >
      {both && (
        <Typography variant="XS" style={styleText} className={cn(leadingNone)}>
          {label}
        </Typography>
      )}
      {both && (
        <View className="h-full bg-text" style={{ width: 1, opacity: 0.25 }} />
      )}
      <Typography variant="XSB" style={styleText} className={cn(leadingNone)}>
        {both ? value : label}
      </Typography>
    </Animated.View>
  )
}
